import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import TextoReducer from '../texto/textoReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import UsuarioReducer from '../usuario/usuarioReducer';
import IdeiaNegocioReducer from '../ideiaNegocio/ideiaNegocioReducer';
import DicionarioReducer from '../dicionario/dicionarioReducer';
import ParceiroReducer from '../parceiro/parceiroReducer';
import StartupReducer from '../startup/startupReducer';
import EventoReducer from '../evento/eventoReducer';
import MentorReducer from '../mentor/mentorReducer';
import TrilhaConhecimentoReducer from '../trilhaConhecimento/trilhaConhecimentoReducer';
import PreIncubacaoIdeacaoReducer from '../preIncubacaoIdeacao/preIncubacaoIdeacaoReducer';
import PreIncubacaoPrototipoReducer from '../preIncubacaoPrototipo/preIncubacaoPrototipoReducer';
import PreIncubacaoValidacaoReducer from '../preIncubacaoValidacao/preIncubacaoValidacaoReducer';
import PreIncubacaoPitchReducer from '../preIncubacaoPitch/preIncubacaoPitchReducer';
import VideoReducer from '../video/videoReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	texto: TextoReducer,
	dashboard: DashboardReducer,
	usuario: UsuarioReducer,
	ideiaNegocio: IdeiaNegocioReducer,
	dicionario: DicionarioReducer,
	parceiro: ParceiroReducer,
	startup: StartupReducer,
	evento: EventoReducer,
	mentor: MentorReducer,
	trilhaConhecimento: TrilhaConhecimentoReducer,
	preIncubacaoIdeacao: PreIncubacaoIdeacaoReducer,
	preIncubacaoPrototipo: PreIncubacaoPrototipoReducer,
	preIncubacaoValidacao: PreIncubacaoValidacaoReducer,
	preIncubacaoPitch: PreIncubacaoPitchReducer,
	video: VideoReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;

